// MenuContext.js
import PropTypes from "prop-types";
import { createContext, useState, useContext, useEffect  } from "react";

const MenuContext = createContext();

export const useMenu = () => useContext(MenuContext);

export const MenuProvider = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(true);
//   const [isMenuOpen2,setIsMenuOpen2]= useState(false)
useEffect(() => {
  console.log("MenuProvider mounted");
}, []);

useEffect(() => {
  console.log("isMenuOpen changed:", isMenuOpen);
}, [isMenuOpen]);


  return (
    <MenuContext.Provider value={{ isMenuOpen, setIsMenuOpen }}>
      {children}
    </MenuContext.Provider>
  );
};

MenuProvider.propTypes = {
  children: PropTypes.node.isRequired,
};